import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Learning Quran',
        content: 'Comprehensive Quran learning classes for all ages, focusing on proper recitation, understanding, and memorization.',
        paragraphs: [
            'Our qualified Islamic teachers provide structured Quran learning programs, ensuring correct Tajweed, pronunciation, and understanding of Quranic meanings for beginners and advanced learners.',
            'We offer personalized learning plans based on age, skill level, and individual goals, including Quran reading, memorization (Hifz), and Tafseer.'
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Experienced and certified Quran teachers',
            'Structured curriculum for beginners to advanced learners',
            'Focus on Tajweed and correct pronunciation',
            'Flexible online and in-person classes',
            'Progress tracking and regular feedback for students'
        ],
        process: [
            'Student assessment and skill level evaluation',
            'Personalized Quran learning plan creation',
            'Interactive teaching sessions with Tajweed focus',
            'Regular practice and memorization monitoring',
            'Final evaluation and progress certification'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What age group can join?',
                content: 'We offer classes for children, teenagers, and adults with separate programs for each group.'
            },
            {
                id: 2,
                heading: 'Do you offer online Quran classes?',
                content: 'Yes, we provide online classes with live instructors for students worldwide.'
            },
            {
                id: 3,
                heading: 'How long will it take to complete learning?',
                content: 'It depends on your goals—basic recitation can be learned in 3-6 months, while Hifz may take 2-4 years.'
            },
            {
                id: 4,
                heading: 'Do you teach Tajweed rules?',
                content: 'Yes, Tajweed is an essential part of all our Quran learning programs.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Marriage Service',
        content: 'Comprehensive marriage services designed to create a memorable and stress-free wedding experience.',
        paragraphs: [
            'We offer complete wedding planning and coordination, ensuring every detail is managed from start to finish for a flawless celebration.',
            'Our team tailors each wedding to your unique preferences, culture, and traditions, making your special day truly one-of-a-kind.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Experienced wedding planners and coordinators',
            'Custom themes and decoration packages',
            'Vendor selection and contract management',
            'Legal and documentation assistance',
            'On-site coordination and event management'
        ],
        process: [
            'Initial consultation to understand requirements',
            'Theme and concept development',
            'Vendor booking and service confirmation',
            'Pre-wedding rehearsal and final arrangements',
            'Wedding day coordination and support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you handle destination weddings?',
                content: 'Yes, we offer full planning and coordination for both local and international destination weddings.'
            },
            {
                id: 2,
                heading: 'Can you customize wedding themes?',
                content: 'Absolutely! We create personalized themes that reflect your style, culture, and vision.'
            },
            {
                id: 3,
                heading: 'Do you manage vendor payments?',
                content: 'Yes, we handle vendor contracts and payments to ensure a hassle-free process for you.'
            },
            {
                id: 4,
                heading: 'Do you assist with legal paperwork?',
                content: 'Yes, we guide you through all legal requirements, including marriage licenses and documentation.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Counseling',
        content: 'Professional counseling services to guide individuals and couples through life’s challenges with understanding.',
        paragraphs: [
            'We provide confidential counseling sessions to address personal, marital, and family issues in a safe and supportive environment.',
            'Our experienced counselors use proven techniques to help clients achieve clarity, healing, and personal growth.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'One-on-one counseling',
            'Pre-marital guidance',
            'Marital and family therapy',
            'Conflict resolution strategies',
            'Confidential and empathetic approach'
        ],
        process: [
            'Initial assessment and goal setting',
            'Customized counseling plan',
            'Regular follow-up sessions',
            'Progress evaluation',
            'Long-term emotional support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Is counseling confidential?',
                content: 'Yes, all sessions are completely private and confidential.'
            },
            {
                id: 2,
                heading: 'Do you offer online counseling?',
                content: 'Yes, we provide both in-person and virtual counseling sessions.'
            },
            {
                id: 3,
                heading: 'Can couples attend sessions together?',
                content: 'Absolutely, we offer joint counseling for couples.'
            },
            {
                id: 4,
                heading: 'How long is each session?',
                content: 'Sessions typically last 45–60 minutes, depending on your needs.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Community Service',
        content: 'Engaging in meaningful initiatives that uplift, support, and strengthen the community through various programs.',
        paragraphs: [
            'We organize and participate in community service projects aimed at improving the well-being of individuals and families.',
            'Our goal is to foster unity, compassion, and social responsibility through impactful outreach and volunteer work.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'Food and clothing drives',
            'Educational workshops',
            'Health and wellness programs',
            'Youth development activities',
            'Volunteer opportunities'
        ],
        process: [
            'Identify community needs',
            'Plan and organize programs',
            'Mobilize volunteers and resources',
            'Execute outreach activities',
            'Measure impact and improve initiatives'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How can I volunteer?',
                content: 'You can register through our website or contact us directly to join our volunteer programs.'
            },
            {
                id: 2,
                heading: 'Do you accept donations?',
                content: 'Yes, we accept monetary and in-kind donations to support our community projects.'
            },
            {
                id: 3,
                heading: 'Are the programs free?',
                content: 'Most of our community services are free, supported by donations and volunteer efforts.'
            },
            {
                id: 4,
                heading: 'Do you collaborate with other organizations?',
                content: 'Yes, we partner with local and national organizations to maximize our community impact.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Mosque Development',
        content: 'Supporting the growth, renovation, and maintenance of mosques to create welcoming spaces for worship.',
        paragraphs: [
            'We are committed to building and enhancing mosque facilities to meet the needs of the growing community.',
            'Our efforts ensure that mosques remain centers of spiritual growth, education, and unity.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            'New mosque construction',
            'Renovation and expansion projects',
            'Maintenance and upkeep',
            'Accessibility improvements',
            'Community prayer hall enhancements'
        ],
        process: [
            'Assess current mosque needs',
            'Plan and design projects',
            'Fundraise and gather resources',
            'Execute construction or renovation',
            'Monitor and maintain facilities'
        ],
        faqs: [
            {
                id: 1,
                heading: 'How can I contribute to mosque development?',
                content: 'You can donate funds, materials, or volunteer your time for construction and maintenance work.'
            },
            {
                id: 2,
                heading: 'Do you accept international donations?',
                content: 'Yes, we welcome contributions from both local and international supporters.'
            },
            {
                id: 3,
                heading: 'Can I sponsor a specific project?',
                content: 'Yes, you can choose to sponsor a particular development or renovation project.'
            },
            {
                id: 4,
                heading: 'How are the funds used?',
                content: 'All donations are allocated transparently toward construction, renovation, and maintenance efforts.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Funeral Service',
        content: 'Providing compassionate and respectful funeral arrangements, ensuring Islamic traditions are honored.',
        paragraphs: [
            'We offer complete funeral services to guide families through every step with empathy and dignity.',
            'Our team ensures that all arrangements follow Islamic practices, from preparation to burial.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Body preparation according to Islamic rites',
            'Janazah prayer arrangements',
            'Transportation to burial site',
            'Grave preparation',
            'Support for grieving families'
        ],
        process: [
            'Receive notification and provide immediate assistance',
            'Prepare the body in accordance with Islamic guidelines',
            'Coordinate with family and community for Janazah prayer',
            'Arrange transport and burial',
            'Offer continued family support'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Do you provide 24/7 funeral services?',
                content: 'Yes, our funeral team is available at all times to assist during emergencies.'
            },
            {
                id: 2,
                heading: 'Can you help with international body repatriation?',
                content: 'Yes, we assist in arranging all documentation and transport for international repatriation.'
            },
            {
                id: 3,
                heading: 'Are the services free of charge?',
                content: 'Some services are subsidized through community donations, while others may have minimal costs.'
            },
            {
                id: 4,
                heading: 'Do you offer grief counseling?',
                content: 'Yes, we provide counseling and emotional support for bereaved families.'
            }
        ]
    }

];

export default services;